import React,{useState,useEffect} from 'react';
import Blank from '../iconpages/blanks';
import ProjectMasterList from '../iconpages/ProjectMasterList';
import JACAssignment from '../iconpages/JACAssignment';
import JACConsultant from '../iconpages/JACConsultant';
import RVWSStatus from '../iconpages/RVWSStatus';
import SubmissionReport from '../iconpages/SubmissionReport';
import AuthoritiesList from '../iconpages/AuthoritiesList';
import FinalAccountList from '../iconpages/FinalAccountList';
import SubmissionStatus from '../iconpages/SubmissionStatus';
import SeniorManagement from '../iconpages/SeniorManagement';
import SafetyStatisticReport from '../iconpages/SafetyStatisticReport';
import ProjectItems from '../iconpages/ProjectItems';
import ProjectItemsChecklist from '../iconpages/ProjectItemsChecklist';
import MonthlyProjectStatusReport from '../iconpages/MonthlyProjectStatusReport';
import SummaryCost from '../iconpages/SummaryCost';
import { useLocation } from 'react-router-dom';

function ChecklistAcc() {
  const location = useLocation();
  // const [currentComponent, setCurrentComponent] = useState(<ProjectMasterList/>);
  // const [activeButton, setActiveButton] = useState('projectMasterList');
    const [currentComponent, setCurrentComponent] = useState();
  const [activeButton, setActiveButton] = useState();
  const handleComponentChange = (component, buttonId) => {
    setActiveButton(buttonId);
    setCurrentComponent(component);
  };

  const [name, setName] = useState('');
  const accountId = localStorage.getItem('userDetails');

  useEffect(()=>{
    if(accountId){
      const userDetails = JSON.parse(accountId);
      setName(userDetails.name);
    }
  },[])


  useEffect(()=>{
      const getSearch = location.search;
      if(getSearch.includes('projectMasterList')){
        handleComponentChange(<ProjectMasterList />, 'projectMasterList')
      } else if(getSearch.includes('jacAssignment')){
        handleComponentChange(<JACAssignment />, 'jacAssignment')
      } else if(getSearch.includes('jacConsultant')){
        handleComponentChange(<JACConsultant />, 'jacConsultant')
      } else if(getSearch.includes('rvwsStatus')){
        handleComponentChange(<RVWSStatus />, 'rvwsStatus')
      } else if(getSearch.includes('submissionReport')){
        handleComponentChange(<SubmissionReport />, 'submissionReport')
      } else if(getSearch.includes('authoritiesList')){
        handleComponentChange(<AuthoritiesList />, 'authoritiesList')
      } else if(getSearch.includes('finalAccountList')){
        handleComponentChange(<FinalAccountList />, 'finalAccountList')
      } else if(getSearch.includes('submissionStatus')){
        handleComponentChange(<SubmissionStatus />, 'submissionStatus')
      } else if(getSearch.includes('safetyStatisticReport')){
        handleComponentChange(<SafetyStatisticReport />, 'safetyStatisticReport')
      } else if(getSearch.includes('projectItems')){
        handleComponentChange(<ProjectItems />, 'projectItems')
      } else if(getSearch.includes('projectItemsChecklist')){
        handleComponentChange(<ProjectItemsChecklist />, 'projectItemsChecklist')
      } else if(getSearch.includes('summaryCost')){
        handleComponentChange(<SummaryCost />, 'summaryCost')
      } else if(getSearch.includes('monthlyProjStsReport')){
        handleComponentChange(<MonthlyProjectStatusReport />, 'monthlyProjStsReport')
      }else if(getSearch.includes('seniorManagement')){
        handleComponentChange(<SeniorManagement />, 'seniorManagement')
      }

    },[location])

  return (
    <div className="wbshor">
      <div className="login-header-wrap">
        <div className="login-header">
          <div className="pagetitle">{name}</div>
          <div className="button-wrapper">
            {/* <button className="btntopright" id="optionsBtn"><p>&lt;</p></button> */}
            <div className="options-popup" id="optionsPopup">
              <button className="option-btn yellow">Filter <i>▼</i></button>
              <button className="option-btn">Export report <i>▼</i></button>
              <button className="option-btn">Hide Columns <i>▼</i></button>
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="innerwrap">
          <div className="leftbar">            
            <button
              className={`option-btn btn1 ${activeButton === 'projectMasterList' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<ProjectMasterList />, 'projectMasterList')}
            >
              Project Master List
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'jacAssignment' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<JACAssignment />, 'jacAssignment')}
            >
              JAC Assignment of Term Contractor
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'jacConsultant' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<JACConsultant />, 'jacConsultant')}
            >
              JAC Assignment of Term Consultant
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'rvwsStatus' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<RVWSStatus />, 'rvwsStatus')}
            >
              RVWS Status
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'submissionReport' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<SubmissionReport />, 'submissionReport')}
            >
              Submission of Procurement Papers
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'authoritiesList' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<AuthoritiesList />, 'authoritiesList')}
            >
              Authorities Submission Schedule
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'finalAccountList' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<FinalAccountList />, 'finalAccountList')}
            >
              Final Account Closure
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'monthlyProjStsReport' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<MonthlyProjectStatusReport />, 'monthlyProjStsReport')}
            >
              Monthly Project Status Report
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'seniorManagement' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<SeniorManagement />, 'seniorManagement')}
            >
              Senior Management
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'safetyStatisticReport' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<SafetyStatisticReport />, 'safetyStatisticReport')}
            >
              Safety Statistic Report
            </button>

            <button
              className={`option-btn btn1 ${activeButton === 'projectItemsChecklist' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<ProjectItemsChecklist />, 'projectItemsChecklist')}
            >
              Project Items Checklist
            </button>

            {/* <button
              className={`option-btn btn1 ${activeButton === 'summaryCost' ? 'active' : ''}`}
              onClick={() => handleComponentChange(<SummaryCost />, 'summaryCost')}
            >
              Summary Cost Norm
            </button> */}
          </div>

          {currentComponent}
        </div>
      </div>
    </div>
  );
}

export default ChecklistAcc;
